import { axios, BaseApiUrl,BaseUrl} from '../../axios_config';


//查询入库单报表
export const getDeliveryOrderTaskAsync = params => {
    return axios.post(`${BaseApiUrl}/TFDeliveryInfo/GetDeliveryOrderTaskAsync`, params);
};

//查询预约信息
export const getDeliveryBookingAsync = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/GetDeliveryBookingAsync`, { params: params });
};

//导出入库单
export const exportDeliveryOrderAsync = `${BaseApiUrl}/TFDeliveryInfo/DeliveryOrderAsyncOut`;

//签收
export const insertTFSignFor = params => {
    return axios.post(`${BaseApiUrl}/TFDeliveryInfo/InsertTFSignFor`, params);
};

//导入入库箱数据
export const importTFDeliveryBox = `${BaseApiUrl}/TFDeliveryInfo/ImportTFDeliveryBox`;

//创建进仓单
export const addTFDelivery = params => {
    return axios.post(`${BaseApiUrl}/TFDeliveryInfo/AddTFDelivery`, params);
};

//查询进仓单明细
export const getTFDeliveryOrderById = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/GetTFDeliveryOrderById`, { params: params });
};

//导出进仓单箱明细数据
export const deliveryBoxInfoAsyncOut = `${BaseApiUrl}/TFDeliveryInfo/DeliveryBoxInfoAsyncOut`;

//取消进仓单
export const cancelTFDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/CancelTFDeliveryOrder`, { params: params });
};

//回滚进仓单
export const rollbackTFDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/RollBackTFDeliveryOrder`, { params: params });
};

//同步进仓单
export const asyncTFDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/AsyncTFDeliveryOrder`, { params: params });
};

//审核进仓单
export const examineDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/ExamineDeliveryOrder`, { params: params });
};

//导出模板
export const downloadDeliveryBox = `${BaseUrl}/template/transfer/进仓单箱明细模板.xlsx`;
//打印查询明细
export const printDeliveryOrderAsync = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/PrintDeliveryOrderAsync`, { params: params });
};

//强制完成进仓单
export const forceCompleteDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/ForceCompleteDeliveryOrder`, { params: params });
};

// 查询进仓单详情
export const GetDeliveryBoxInfoTaskAsyncApi = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/GetDeliveryBoxInfoTaskAsync`, { params: params });
};

//库存转移
export const changeStockDeliveryOrder = params => {
    return axios.get(`${BaseApiUrl}/TFDeliveryInfo/ChangeStockDeliveryOrder`, { params: params });
};